module.exports = __webpack_public_path__ + "img/kv.2570e427.png";